import { render } from "./SupportBanner.vue?vue&type=template&id=45c38b25&scoped=true"
import script from "./SupportBanner.vue?vue&type=script&lang=js"
export * from "./SupportBanner.vue?vue&type=script&lang=js"

import "./SupportBanner.vue?vue&type=style&index=0&id=45c38b25&lang=css"
import "./SupportBanner.vue?vue&type=style&index=1&id=45c38b25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c38b25"]])

export default __exports__